import EvaluationsIndex from './views/index';
import EvaluationsNew from './views/new';
import EvaluationEdit from './views/edit';

export default [
    {
        path: '/',
        name: 'EvaluationsIndex',
        component: EvaluationsIndex,
        meta: {layout: "layoutUser", pageOrder: 4, pageSubOrder: 1}
    },
    {
        path: '/evaluations/new',
        name: 'EvaluationsNew',
        component: EvaluationsNew,
        meta: {layout: "layoutUser", pageOrder: 4, pageSubOrder: 2, isProtected: true, feature: 'create_evaluation'}
    },
    {
        path: '/evaluations/:id',
        name: 'EvaluationEdit',
        component: EvaluationEdit,
        meta: {layout: "layoutUser", pageOrder: 4, pageSubOrder: 2}
    }
]